/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.branding.rpc.BrandAndSiteSettingsDiffRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const getBrandAndSiteSettingsDiffsRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandAndSiteSettingsDiffRpc',
  rpcName: 'getBrandAndSiteSettingsDiffs',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAmKsHTVmqbmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateBrandAndSiteSettingsDiffsRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandAndSiteSettingsDiffRpc',
  rpcName: 'updateBrandAndSiteSettingsDiffs',
  auth: 'app',
  fingerprint: 'Q0GFRW3RCC2OUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const isPortalUngatedToMigrationRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandAndSiteSettingsDiffRpc',
  rpcName: 'isPortalUngatedToMigration',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABJn9uYejBai5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};